export enum FilterOperationDialogEnum {
  CONTAINS = 'contains',
  DOES_NOT_CONTAIN = 'notcontains',
  STARTS_WITH = 'startswith',
  ENDS_WITH = 'endswith',
  HAS_VALUE = 'has_value',
  DOES_NOT_HAVE_VALUE = 'does_not_have_value',
  EQUALS = '=',
  NOT_EQUALS = '<>',
  LESS_THAN = '<',
  GREATER_THAN = '>',
  LESS_EQUALS_THAN = '<=',
  GREATER_EQUALS_THAN = '>=',
}
